export const sortBundledGraphics = (graphics: Graphic[]): Graphic[] => {
	const bundles = graphics.filter((g) => g.types.includes("bundle"));
	const children = graphics.filter((g) => g.parentId && g.types.includes("general"));

	const childrenByParent = children.reduce<Record<string, Graphic[]>>((acc, child) => {
		if (child.parentId) {
			if (!acc[child.parentId]) {
				acc[child.parentId] = [];
			}
			acc[child.parentId].push(child);
		}
		return acc;
	}, {});

	return bundles.flatMap((bundle) => [bundle, ...(childrenByParent[bundle.id] || [])]);
};
